{
  "display-rr-1": {
    "slot": "/6355419/Travel/Europe/France/Paris",
    "sizes": [[300, 250]]
  },
  "display-rr-2": {
    "slot": "/6355419/Travel/Europe/France/Paris",
    "sizes": [[300, 250]]
  },
  "display-rr-3": {
    "slot": "/6355419/Travel/Europe/France/Paris",
    "sizes": [[300, 250]]
  },
  "display-lr-1": {
    "slot": "/6355419/Travel/Europe/France/Paris",
    "sizes": [[300, 600], [160, 600], [300, 250]]
  },
  "display-desktop-anchor": {
    "slot": "/6355419/Travel/Europe/France/Paris",
    "sizes": [[728, 90]]
  },
  "display-skin": {
    "slot": "/6355419/Travel/Europe/France/Paris",
    "sizes": [[1, 1]]
  }
}
